const ACCORDION_DURATION = 250;
const ACCORDION_EASING = 'ease';

function expandAccordion(details, content) {
  details.classList.add('is-animating');
  details.open = true;

  const endHeight = content.scrollHeight;
  content.style.overflow = 'hidden';

  const animation = content.animate(
    { height: ['0px', `${endHeight}px`] },
    { duration: ACCORDION_DURATION, easing: ACCORDION_EASING }
  );

  animation.onfinish = () => {
    content.style.overflow = '';
    content.style.height = '';
    details.classList.remove('is-animating');
  };
}

function collapseAccordion(details, content) {
  details.classList.add('is-animating');

  const startHeight = content.scrollHeight;
  content.style.overflow = 'hidden';

  const animation = content.animate(
    { height: [`${startHeight}px`, '0px'] },
    { duration: ACCORDION_DURATION, easing: ACCORDION_EASING }
  );

  animation.onfinish = () => {
    details.open = false;
    content.style.overflow = '';
    content.style.height = '';
    details.classList.remove('is-animating');
  };
}

document.addEventListener('click', (event) => {
  const summary = event.target.closest('.accordion > details > summary');
  if (!summary) return;

  const details = summary.parentElement;
  const content = details.querySelector(':scope > .accordion__content');
  if (!content) return;

  event.preventDefault();

  if (details.classList.contains('is-animating')) return;

  if (details.open) {
    collapseAccordion(details, content);
  } else {
    expandAccordion(details, content);
  }
});
